import Body from "./Body";
import Filter from "./Filter";
import Search from "./Search";
import Invoice from "./Invoice";

export const Components = {
  Body,
  Filter,
  Search,
  Invoice,
};
